
import { useState } from 'react';

interface ShareButtonsProps {
  title: string;
  slug: string;
}

export default function ShareButtons({ title, slug }: ShareButtonsProps) {
  const [copied, setCopied] = useState(false);
  const url = `https://tgweb.com.br/blog/${slug}`;
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const shareLinks = [
    {
      name: 'Facebook',
      icon: 'ri-facebook-fill',
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      color: 'bg-[#1877F2] hover:bg-[#166FE5]',
    },
    {
      name: 'Twitter',
      icon: 'ri-twitter-x-fill',
      href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
      color: 'bg-neutral-900 hover:bg-neutral-800',
    },
    {
      name: 'LinkedIn',
      icon: 'ri-linkedin-fill',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      color: 'bg-[#0A66C2] hover:bg-[#094D92]',
    },
    {
      name: 'WhatsApp',
      icon: 'ri-whatsapp-fill',
      href: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`,
      color: 'bg-[#25D366] hover:bg-[#20BD5A]',
    },
  ];

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch (error) {
      // Optional fallback: alert the user
      console.error('Failed to copy link:', error);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <span className="text-sm font-semibold text-neutral-700">Compartilhar</span>
      <div className="flex items-center gap-2 flex-wrap">
        {shareLinks.map((link) => (
          <a
            key={link.name}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer nofollow"
            title={`Compartilhar no ${link.name}`}
            className={`w-10 h-10 flex items-center justify-center rounded-lg text-white transition-all cursor-pointer ${link.color}`}
          >
            <i className={`${link.icon} text-lg`}></i>
          </a>
        ))}
        <button
          onClick={handleCopyLink}
          title="Copiar link"
          className={`w-10 h-10 flex items-center justify-center rounded-lg transition-all cursor-pointer whitespace-nowrap ${
            copied
              ? 'bg-green-100 text-green-600'
              : 'bg-neutral-100 text-neutral-600 hover:bg-neutral-200'
          }`}
        >
          <i className={`${copied ? 'ri-check-line' : 'ri-link'} text-lg`}></i>
        </button>
      </div>
    </div>
  );
}
